<template>
    <div class="market_filter">
        <b-overlay :show="is_load">
            <b-tabs pills card vertical>
                <b-tab
                    v-for="(market, idx) in markets"
                    :key="market.type"
                    :active="idx === 0"
                >
                    <template #title>
                        <div class="fs-lg px-4 text-center position-relative">
                            {{ __t(market.type) }}

                            <span class="badge badge-icon pos-top pos-right" v-if="selectedInMarket(market) > 0">
                               {{selectedInMarket(market)}}
                            </span>
                        </div>
                    </template>

                    <b-card-text>
                        <div v-if="market._loading" class="text-muted py-3">Завантаження…</div>

                        <b-list-group v-else>
                            <b-list-group-item
                                v-for="loc in market.locations"
                                :key="`m${market.id}_l${loc.id}`"
                                class="d-flex align-items-center justify-content-between"
                            >
                                <div class="text-truncate pr-3">
                                    {{ loc.title }}
                                    <div>
                                        {{loc.uniq_id}}
                                    </div>
                                </div>

                                <div class="custom-control custom-switch">
                                    <input
                                        :id="`loc-${market.id}-${loc.id}`"
                                        type="checkbox"
                                        class="custom-control-input"
                                        :checked="role_item.delivery_ids.includes(loc.id)"
                                        @change="toggleLocation(market, loc)"
                                    >
                                    <label class="custom-control-label" :for="`loc-${market.id}-${loc.id}`"></label>
                                </div>
                            </b-list-group-item>

                            <b-list-group-item v-if="!market.locations.length" class="text-muted">
                                Немає локацій
                            </b-list-group-item>
                        </b-list-group>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: "role_delivery",
    props : {
        role_item : {
            type : Object
        }
    },

    created() {
        this.hydrateFromProps();
        this.load_markets();
    },

    data() {
        return {
            cur_item : {
                'provider_id' : 0
            },
            cur_provider : {
                'id' : 0,
                'name' : "",
                'type' : ""
            },

            is_load: false,
            restaurants : [],
            locations : [],
            markets : [],
            is_set_data : false,
        }
    },

    methods: {

        selectedInMarket(market) {
            if (!market.locations) return 0;
            return market.locations.filter(l => this.selectedIds.has(l.id)).length;
        },


        hydrateFromProps() {
            console.log(this.role_item);
            this.selectedIds = new Set(Array.isArray(this.role_item.delivery_ids) ? this.role_item.delivery_ids : []);
        },

        async load_markets() {
            this.is_load = true;
            this.markets = [];
            try {
                const { data } = await delivery_api.get('/deliveries/active');

                // 1) фильтрация по type, начинающемуся с "ext" (case-insensitive)
                const raw = (data?.data || []).filter(m => {
                    const t = (m.type || m.name || m.human_name || '').toString();
                    return !/^ext/i.test(t);
                });

                // 2) параллельно тянем локации; при ошибке — маркет игнорируем
                const promises = raw.map(async (m) => {
                    const market = { ...m, locations: [], _loading: true };
                    try {
                        const resp = await this.load_locations(m.id);
                        const locs = resp?.data?.data || resp?.data || [];
                        market.locations = locs.map(l => ({ ...l, enabled: !!l.enabled }));
                        market._loading = false;
                        return market;
                    } catch {
                        return null;
                    }
                });

                const result = await Promise.all(promises);
                this.markets = result.filter(Boolean); // выкидываем null’ы
            } catch (e) {
                EventBus.$emit('show_toast', {
                    err: e?.response?.data?.message || 'Помилка завантаження маркетів',
                    type: 'danger',
                    title: e?.response?.data?.status || 'Error'
                });
            } finally {
                this.is_load = false;
            }
        },

        load_locations(market_id) {
            return delivery_api.get(`/deliveries/${market_id}/locations`);
        },

        async toggleLocation(market, loc) {
            const id = loc.id;

            // Текущий массив id-шников
            const ids = Array.isArray(this.role_item.delivery_ids)
                ? [...this.role_item.delivery_ids]
                : [];

            if (ids.includes(id)) {
                // выключаем — удаляем из массива
                this.role_item.delivery_ids = ids.filter(lid => lid !== id);
            } else {
                // включаем — добавляем в массив
                this.role_item.delivery_ids = [...ids, id];
            }

            // Прокидываем наверх событие с готовым массивом
            this.$emit('on_change_attribute', 'delivery_ids',this.role_item.delivery_ids);
        }
    }
}
</script>



<style scoped>

</style>
